import produce from 'immer';
import { combineReducers } from 'redux';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { SecretActions, SecretActionType } from '../../actions/secretActions';
import { parseJsonString } from '../../utils/formatKeyValuePairHelper';
import { Secret } from '../../types/resources';

interface SecretState {
  byName: Record<string, Secret | RcInstanceDTO.SecretListItem>;
  allNames: string[];
}

export const initialState: SecretState = {
  byName: {},
  allNames: [],
};

const byName = (state = initialState.byName, action: SecretActions) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SecretActionType.GET_SECRET_LIST_ITEMS:
        return {};
      case SecretActionType.GET_SECRET_LIST_ITEMS_OK: {
        action.data.forEach((secret) => {
          draft[secret.name] = secret;
        });

        break;
      }
      case SecretActionType.GET_SECRET_OK: {
        const parsedData = parseJsonString(action.data.value);

        draft[action.data.name] = {
          ...action.data,
          value: parsedData,
        };

        break;
      }
      case SecretActionType.PUT_SECRET_OK: {
        draft[action.data.name] = {
          ...action.data,
          value: action.data.value,
        } as RcInstanceDTO.Secret;
        break;
      }
      case SecretActionType.DELETE_SECRET_OK: {
        delete draft[action.name];
        break;
      }

      default:
        return state;
    }
  });

const allNames = (state = initialState.allNames, action: SecretActions) => {
  switch (action.type) {
    case SecretActionType.GET_SECRET_LIST_ITEMS:
      return [];
    case SecretActionType.GET_SECRET_LIST_ITEMS_OK:
      return action.data.map((secret) => secret.name);
    case SecretActionType.DELETE_SECRET_OK:
      return state.filter((id) => id !== action.name);
    case SecretActionType.PUT_SECRET_OK:
      if (!state.includes(action.data.name)) {
        return [...state, action.data.name];
      }
      return state;

    default:
      return state;
  }
};

export default combineReducers({
  allNames,
  byName,
});
